// src/pages/Pricing.js
import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import '../styles.css';

export default function Pricing() {

  return (
    <>
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <PublicHeader />

      <div className="pricing-container">
        <h1>Choose your plan</h1>
        <p style={{ fontSize: '1.25rem', color: '#555', maxWidth: '700px', margin: '0 auto 60px' }}>
          All plans include a <strong>30-day free trial</strong> — no payment method required.
        </p>

        <div className="pricing-grid">
          {/* Free */}
          <div className="pricing-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '450px' }}>
            <div>
              <h2>Free</h2>
              <ul style={{ listStyle: 'none', padding: 0, margin: '20px 0', textAlign: 'left' }}>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Access to tire size calculator</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Access to alignment converter</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Use the excuse generator as the need arises</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• More free features coming all the time!</li>
              </ul>
            </div>
            <button
              onClick={() => window.location.href = '/register'}
              className="btn trial-btn"
              style={{ minHeight: '52px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              Start 30 Day Free Trial
            </button>
          </div>

          {/* Enthusiast */}
          <div className="pricing-card" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '450px' }}>
            <div>
              <h2>Enthusiast</h2>
              <div className="price">$7<span style={{fontSize:'0.6em'}}>/month</span></div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '10px 0', textAlign: 'left' }}>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Up to 2 vehicles</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Unlimited events</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Unlimited sessions</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Custom vehicle parameters</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Data backup</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Community Support</li>
              </ul>
            </div>
            <button
              onClick={() => window.location.href = '/register'}
              className="btn trial-btn"
              style={{ minHeight: '52px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              Start 30 Day Free Trial
            </button>
          </div>

          {/* Pro */}
          <div className="pricing-card pro" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', minHeight: '450px' }}>
            <div>
              <div className="popular-badge">Most Popular</div>
              <h2>Pro</h2>
              <div className="price">$21<span style={{fontSize:'0.6em'}}>/month</span></div>
              <ul style={{ listStyle: 'none', padding: 0, margin: '10px 0', textAlign: 'left' }}>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Unlimited vehicles</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Tire Manager</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Track map notes</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Excel data export</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Compensations</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Priority Support</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Team Collaboration</li>
                <li style={{ marginBottom: '0px', fontSize: '1.1em' }}>• Much More!</li>
              </ul>
            </div>
            <button
              onClick={() => window.location.href = '/register'}
              className="btn trial-btn"
              style={{ minHeight: '52px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            >
              Start 30 Day Free Trial
            </button>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}